import { Factory } from 'rosie';

Factory.define('VgsAccountContent');
Factory.define('VgsAccountSecretContent');

Factory.define('VgsAccountContentWithDefaults')
  .extend('VgsAccountContent')
  .attr('vaultEnvironment', 'SANDBOX')
  .attr('vaultId', 'a-vault-id');



// WEBPACK FOOTER //
// ./factories/vgs_account_content_factory.js